import pdf from '../../../assets/Docs/contratov3.pdf'
import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { PDFDocument, rgb } from 'pdf-lib';
import { showDataid } from "../../../service/Contrato/showData";
import fontkit from '@pdf-lib/fontkit'; 
import italicfont from '../../../assets/fonts/semiboldi.ttf'
// import { number } from 'yup';

export default function DocData() {
  const [pdfUrl, setPdfUrl] = useState(null);
  const TOKEN = window.sessionStorage.getItem("token");
  const METOD0="GET";
  const API = "/portal/";
  const id_result = useParams()
  const [result, setResult] = useState([]);
  var fecha;
  var fechafin;

  useEffect(() => {
      showDataid(id_result.id, METOD0, TOKEN, API)
          .then((resultinfo) => {
              setResult(resultinfo);
          })
          .catch((error) => console.log("Error:", error));
  }, []);

  var Mes1, Mes2, Mes3, Mes4, Mes5, Mes6, Mes7, Mes8, Mes9, Mes10, Mes11, Mes12, Reconexion, day, mounth, year, new_year, fecha_create;
  
  const showDataTime = () => {
      fecha_create = new Date(result.date_creation);
      day = fecha_create.getDate();
      mounth = fecha_create.getMonth()+1;
      year = fecha_create.getFullYear();
      new_year = fecha_create.getFullYear()+1;
      fecha = (""+day+"/"+mounth+"/"+year+"");
      fechafin = (""+day+"/"+mounth+"/"+new_year+"");

  };

  const meses = () => {
    const plans = {
        'TRP': 30000,
        'DBL': 20000,
        'DPL': 20000,
        'INT': 20000,
    };

    const planMapping = {
        'TRP': [
            "58.033", "116.067", "174.100", "232.133", "290.167", "348.200",
            "406.233", "464.267", "522.300", "580.333", "638.367", "696.400",
        ],
        'DBL': [
            "43.033", "86.067", "129.100", "172.133", "215.167", "258.200",
            "301.233", "344.267", "387.300", "430.333", "473.367", "516.400",
        ],
        'DPL': [
            "32.350", "64.700", "97.050", "129.400", "161.750", "194.100",
            "226.450", "258.800", "291.150", "323.500", "355.850", "388.200",
        ],
        'INT': [
            "17.350", "34.700", "52.050", "69.400", "86.750", "104.100",
            "121.450", "138.800", "156.150", "173.500", "190.850", "208.200",
        ],
    };

    if (result.plan !== undefined) {
        const planKeys = Object.keys(plans);
        for (const key of planKeys) {
            if (result.plan.includes(key) || result.plan.includes(planMapping[key])) {
                Reconexion = new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                    minimumFractionDigits: 0,
                }).format(Math.trunc(plans[key] * 1.19));

                [Mes12, Mes11, Mes10, Mes9, Mes8, Mes7, Mes6, Mes5, Mes4, Mes3, Mes2, Mes1] = planMapping[key];

                break; // Once a match is found, exit the loop
            }
        }
    }
  };

  meses();
  showDataTime();

  const return_plan_positions = () => {
    if (result.plan !== undefined) {
      if (result.plan.includes('TRP') || result.plan.includes('TRIPLE')) {      
        return [
          { x: 89, y: 720 }, // telefonía
          { x: 162, y: 720 }, // internet
          { x: 229, y: 720 }, // tv
        ];  
      }else if (result.plan.includes('DBL') || result.plan.includes('DOBLE')){
        return [
          { x: 89, y: 720 }, // telefonía
          { x: 162, y: 720 },  // internet
        ];
      }else if (result.plan.includes('DPL') || result.plan.includes('DUPLA')){
        return [
          { x: 89, y: 720 }, // telefonía 
          { x: 162, y: 720 }, // internet 
        ];
      }else if (result.plan.includes('INT') || result.plan.includes('Internet')){
        return [
          { x: 162, y: 720 }, // internet
        ];
      }
    } else {
      return 'N/A';
    }
  }

  const pdfFields = {
    contractNumber: {
      number: result.id || 'N/A',
      x: 510,
      y: 979,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    fecha: {
      number: fecha || 'N/A',
      x: 48,
      y: 821,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    renovacion: {
      number: 'X',
      x: 227,
      y: 794,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    price_plan: {
      number: result.price_plan || 'N/A',
      x: 172,
      y: 848,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    late_instalation: {
      number: result.late_instalation || 'Por asignar',
      x: 220,
      y: 667,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    meses: {
      number: '12',
      x: 155,
      y: 835,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    contract : {
      number: result.contract || 'N/A',
      x: 92,
      y: 609,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    phone_fijo : {
      number: result.phone_fijo || 'N/A',
      x: 192,
      y: 597,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    owner_name : {
      number: result.owner_name || 'N/A',
      x: 134,
      y: 585,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    cc : {
      number: result.cc || 'N/A',
      x: 94,
      y: 572,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    email_owner : {
      number: result.email_owner || 'N/A',
      x: 110,
      y: 561,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    contact_phone : {
      number: result.contact_phone || 'N/A',
      x: 147,
      y: 549,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    phone_fijo_2 : {
      number: result.phone_fijo || 'N/A',
      x: 242,
      y: 549,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    address_service : {
      number: result.address || 'N/A',
      x: 116,
      y: 538,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    address_suscriptor : {
      number: result.address || 'N/A',
      x: 116,
      y: 524,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    category : {
      number: result.category || 'N/A',
      x: 78,
      y: 512,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    estrato : {
      number: result.estrato || 'N/A',
      x: 248,
      y: 512,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    city_owner : {
      number: result.city_owner || 'N/A',
      x: 224,
      y: 500,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    plan : {
      number: result.plan || 'N/A',
      x: 62,
      y: 456,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    price_plan2 : {
      number: result.price_plan || 'N/A',
      x: 218,
      y: 456,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    observations : {
      number: result.observations || 'N/A',
      x: 32,
      y: 88,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    price_plan3 : {
      number: result.price_plan || 'N/A',
      x: 218,
      y: 37,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
  };

  const fieldsPage2 = {
    fechainicio : {
      number: fecha || 'N/A',
      x: 200,
      y: 100,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    fechafin : {
      number: fechafin || 'N/A',
      x: 200,
      y: 86,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes1 : {
      number: Mes1 || 'N/A',
      x: 37,
      y: 46,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes2 : {
      number: Mes2 || 'N/A',
      x: 81,
      y: 46,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes3 : {
      number: Mes3 || 'N/A',
      x: 126,
      y: 46,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes4 : {
      number: Mes4 || 'N/A',
      x: 171,
      y: 46,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes5 : {
      number: Mes5 || 'N/A',
      x: 212,
      y: 46,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes6 : {
      number: Mes6 || 'N/A',
      x: 259,
      y: 46,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes7 : {
      number: Mes7 || 'N/A',
      x: 37,
      y: 22,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes8 : {
      number: Mes8 || 'N/A',
      x: 81,
      y: 22,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes9 : {
      number: Mes9 || 'N/A',
      x: 126,
      y: 22,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes10 : {
      number: Mes10 || 'N/A',
      x: 171,
      y: 22,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes11 : {
      number: Mes11 || 'N/A',
      x: 212,
      y: 22,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    mes12 : {
      number: Mes12 || 'N/A',
      x: 259,
      y: 22,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    reconexion : {
      number: Reconexion || 'N/A',
      x: 400,
      y: 688,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    cc : {
      number: result.cc || 'N/A',
      x: 362,
      y: 84,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    fecha : {
      number: fecha || 'N/A',
      x: 492,
      y: 84,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    asesor : {
      number: result.seller_name || 'N/A',
      x: 402,
      y: 62,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    cc_asesor : {
      number: result.seller_cc || 'N/A',
      x: 402,
      y: 48,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    canalventa : {
      number: 'https://portalservicios.emcali.net.co/',
      x: 402,
      y: 34,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
  };

  const fieldsPage3 = {
    nombre : {
      number: result.owner_name || 'N/A',
      x: 243,
      y: 244,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    tipodoc : {
      number: 'C.C',
      x: 243,
      y: 228,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    cc : {
      number: result.cc || 'N/A',
      x: 243,
      y: 208,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    contrato: {
      number: result.contract || 'N/A',
      x: 243,
      y: 188,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    fecha : {
      number: fecha || 'N/A',
      x: 243,
      y: 150,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
  };

  const fieldsPage5 = {
    nombre : {
      number: result.owner_name || 'N/A',
      x: 100,
      y: 596,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    cc : {
      number: result.cc || 'N/A',
      x: 400,
      y: 262,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    address: {
      number: result.address || 'N/A',
      x: 305,
      y: 200,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    email_owner : {
      number: result.email_owner || 'N/A',
      x: 348,
      y: 177,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    
    ciudad : {
      number: result.city_owner || 'N/A',
      x: 150,
      y: 153,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
    fecha : {
      number: fecha || 'N/A',
      x: 220,
      y: 153,
      size: 10,
      color: rgb(76 / 255, 76 / 255, 77 / 255)
    },
  };

  // const fieldsPage5 = {
  //   nombre : {
  //     number: result.owner_name || 'N/A',
  //     x: 90,
  //     y: 596,
  //     size: 10,
  //     color: rgb(76 / 255, 76 / 255, 77 / 255)
  //   },
  //   cc : {
  //     number: result.cc || 'N/A',
  //     x: 60,
  //     y: 570,
  //     size: 10,
  //     color: rgb(76 / 255, 76 / 255, 77 / 255)
  //   },
  //   cc2 : {
  //     number: result.cc || 'N/A',
  //     x: 400,
  //     y: 262,
  //     size: 10,
  //     color: rgb(76 / 255, 76 / 255, 77 / 255)
  //   },
  //   address: {
  //     number: result.address || 'N/A',
  //     x: 302,
  //     y: 200,
  //     size: 10,
  //     color: rgb(76 / 255, 76 / 255, 77 / 255)
  //   },
  //   email_owner : {
  //     number: result.email_owner || 'N/A',
  //     x: 348,
  //     y: 176,
  //     size: 10,
  //     color: rgb(76 / 255, 76 / 255, 77 / 255)
  //   },
  //   municipio : {
  //     number: result.city_owner || 'N/A',
  //     x: 150,
  //     y: 153,
  //     size: 10,
  //     color: rgb(76 / 255, 76 / 255, 77 / 255)
  //   },
  //   fecha : {
  //     number: fecha || 'N/A',
  //     x: 226,
  //     y: 153,
  //     size: 10,
  //     color: rgb(76 / 255, 76 / 255, 77 / 255)
  //   },
  // };

  useEffect(() => {
    if (result && result.id) {
      const modifyPdf = async () => {
        const existingPdfBytes = await fetch(pdf).then((res) => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        pdfDoc.registerFontkit(fontkit);

        // cargar la fuente
        const fontBytes = await fetch(italicfont).then((res) => res.arrayBuffer());
        const italicFontEmbed = await pdfDoc.embedFont(fontBytes);
  
        Object.values(pdfFields).forEach(field => {
          const fieldValue = String(field.number);
          if (fieldValue.includes('\n')) {
            const lines = fieldValue.split(/\r?\n/); // Divide el texto en líneas
            const lineHeight = 12; // Altura entre líneas
        
            lines.forEach((line, index) => {
              firstPage.drawText(line, {
                x: field.x,
                y: field.y - index * lineHeight, // Ajusta la posición vertical para cada línea
                size: field.size,
                font: italicFontEmbed,
                color: field.color,
              });
            });
          } else {
            // Manejo estándar para campos sin saltos de línea
            firstPage.drawText(fieldValue, {
              x: field.x,
              y: field.y,
              size: field.size,
              font: italicFontEmbed,
              color: field.color,
            });
          }
        });

        const planPositions = return_plan_positions();
        planPositions.forEach(pos => {
          firstPage.drawText('x', {
            x: pos.x,
            y: pos.y,
            size: 12,
            color: rgb(0, 0, 0),
          });
        });

        if (pages.length > 1) {
          const secondPage = pages[1];
          const fourthPage = pages[3];
          const fifthPage = pages[4];
          const image = result.signature ? result.signature : null;
          
          Object.values(fieldsPage2).forEach(field => {
            secondPage.drawText(String(field.number), {
              x: field.x,
              y: field.y,
              size: field.size,
              font: italicFontEmbed,
              color: field.color
            });
          });

          Object.values(fieldsPage3).forEach(field => {
            fourthPage.drawText(String(field.number), {
              x: field.x,
              y: field.y,
              size: field.size,
              font: italicFontEmbed,
              color: field.color
            });
          });

          Object.values(fieldsPage5).forEach(field => {
            fifthPage.drawText(String(field.number), {
              x: field.x,
              y: field.y,
              size: field.size,
              font: italicFontEmbed,
              color: field.color
            });
          });

          // if (image)  {
          //   const imageBytes = await fetch(image).then((res) => res.arrayBuffer());
          //   const pngImage = await pdfDoc.embedPng(imageBytes);
          //   const pngDims = pngImage.scale(0.2);
          //   const pngDims2 = pngImage.scale(0.1);

          //   secondPage.drawImage(pngImage, {
          //     x: 320, 
          //     y: 115, 
          //     width: pngDims.width, 
          //     height: pngDims.height, 
          //   });

          //   fourthPage.drawImage(pngImage, {
          //     x: 243, 
          //     y: 166, 
          //     width: pngDims2.width, 
          //     height: pngDims2.height, 
          //   });

          //   // fifthPage.drawImage(pngImage, {
          //   //   x: 290, 
          //   //   y: 286, 
          //   //   width: pngDims2.width, 
          //   //   height: pngDims2.height, 
          //   // });
          // }

          let imageBytes = null;

          try {
            if (image && image.startsWith("data:image/")) {
              const response = await fetch(image);
              if (!response.ok) throw new Error("Fetch failed");
              imageBytes = await response.arrayBuffer();
              const pngImage = await pdfDoc.embedPng(imageBytes);
              const pngDims = pngImage.scale(0.2);
              const pngDims2 = pngImage.scale(0.3);
              secondPage.drawImage(pngImage, {
                x: 320, 
                y: 115, 
                width: pngDims.width, 
                height: pngDims.height, 
              });
  
              fourthPage.drawImage(pngImage, {
                x: 350, 
                y: 166, 
                width: pngDims2.width, 
                height: pngDims2.height, 
              });
              fifthPage.drawImage(pngImage, {
                x: 340, 
                y: 280, 
                width: pngDims2.width, 
                height: pngDims2.height, 
              });
            } else {
              console.warn("URL de imagen no válida o vacía");
            }
          } catch (error) {
            console.error("Error al obtener la imagen:", error);
          }


          // if (pages.length > 2) {
          //   const thirdPage = pages[4]; 
          //   thirdPage.drawText('Texto en la tercera página', {
          //     x: 350,
          //     y: 50,
          //     size: 12,
          //     color: rgb(0, 0, 0),
          //   });
          // }
        }
  
        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        // const width = firstPage.getWidth();
        // const height = firstPage.getHeight();
        // console.log(`Ancho: ${width}, Alto: ${height}`)

        setPdfUrl(url);
      };
  
      modifyPdf();
    }
  }, [result]); 

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
    if (pdfUrl && isMobile) {
      window.location.href = pdfUrl; // Redirige automáticamente al enlace del PDF
    }
  }, [pdfUrl, isMobile]);
  
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      {pdfUrl ? (
      isMobile ? (
        null
      ) : (
        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          title="PDF Viewer"
          style={{ border: 'none' }}
        />
      )
    ) : (
      <p>Cargando PDF...</p>
    )}
    </div>
  );
}